import HamburgerButton from './components/HamburgerButton';
import LazyBackground from './components/LazyBackground';
import { loader as loadComponents } from './components';
import SlidingDropdown from './components/SlidingDropdown';
import NewsletterForm from './components/NewsletterForm';
import ShareComponent from './components/ShareComponent';
import HeaderListSpaceButton from './components/HeaderListSpaceButton';

/**
 * Provide account specific components
 */
loadComponents({
    SlidingDropdown,
    NewsletterForm,
    share: ShareComponent,
    HamburgerButton,
    HeaderListSpaceButton,
    LazyBackground,
});

// If we haven't loaded a specific page we'll fake the
// to avoid throwing an error
let LoadedPages = [];

LoadedPages.push(import('./components/listing/SpaceListing'));

export default Promise.all(LoadedPages)
    .then((pages) => pages.map(({ default: Page }) => new Page));
